import { Env } from '@stencil/core';

export interface Environment {
  //These are configurable to each teams needs and can add or remove variables as needed
  region: 'eng' | 'test' | 'prod';
  userLocation: 'internal' | 'external';
  site;
  augUrl;
  c3Url;
}

// This is the thing that you should import in your production code so the compiler helps with the interface.
// It's populated at build-time in stencil.config.ts
export const env = Env as unknown as Environment;
